import { Box, Grid, SxProps, Theme, Typography } from "@mui/material";
import { getProPickText } from "../common/proPickUtil";
import { Link } from 'react-router-dom';
import { Button } from "../reusable-components";
import { getDateString } from "../common/RoundHelper";
import kung8 from '../images/kung8.png';
import kung12 from '../images/kung12.png';
import kung13 from '../images/kung13.png';
import video8 from '../images/video_8.jpeg';
import video12 from '../images/video_12.jpeg';
import video13 from '../images/video_13.jpeg';
import mrvegas8 from '../images/mrvegas_8.jpeg';
import mrvegas12 from '../images/mrvegas_12.jpeg';
import mrvegas13 from '../images/mrvegas_13.jpeg';
import mega8 from '../images/mega_8.png';
import mega12 from '../images/mega_12.png';
import mega13 from '../images/mega_13.png';
import comeon8 from '../images/comeon_8.png';
import comeon12 from '../images/comeon_12.png';
import comeon13 from '../images/comeon_13.png';
import snabbare8 from '../images/snabbare_8.png';
import snabbare12 from '../images/snabbare_12.png';
import snabbare13 from '../images/snabbare_13.png';
import reviantBg from '../images/reviant.png';
import hajper8 from '../images/hajper_8.png';
import hajper12 from '../images/hajper_12.png';
import hajper13 from '../images/hajper_13.png';
import stugan8 from '../images/stugan_8.png';
import stugan12 from '../images/stugan_12.png';
import stugan13 from '../images/stugan_13.png';
import stuganSurvivor6 from '../images/stugan_survivor6.png';
import stuganSurvivor8 from '../images/stugan_survivor8.png';
import snabbareSurvivor6 from '../images/snabbare_survivor_6.png';
import snabbareSurvivor8 from '../images/snabbare_survivor_8.png';
import hard13 from '../images/hard_13.png';
import hard12 from '../images/hard_12.png';
import hard8 from '../images/hard_8.png';
import hard9 from '../images/hard_hockey_9.png';
import hardSurvivor from '../images/hard_survivor_65.png';
import unibet_football from '../images/unibet_football.jpg';
import unibet_hockey from '../images/unibet_hockey.png';
import { GetFlexNumber, GetMixMaxFlex, gradientsC, IsLeo, IsOrangeLight, IsVideo, productNamesC, themeC } from "../theme/themehelper";
import { setOrigin, track } from "../analytics/analytics";
import { DbetEightIcon, DbetEightLadder, DbetSixIcon, DbetThirteenIcon, DbetThirteenLadder, DbetTwelveIcon, DbetTwelveLadder, DbetSevenIcon } from "../images/dbeticons";
import useDetailRound from "../rounds/useDetailRound";
import { ReactNode } from "react";
import { ShallowRound } from "../models/round";

interface RobotPlateSlimProps {
    round: ShallowRound;
    t: (key: string) => string;
    sugg: {
        rows: number;
        dif: string;
        numFull: number;
        numHalf: number;
    };
}

function RobotPlateSlim({ round, t, sugg }: RobotPlateSlimProps) {

    const dateString = getDateString(round, t);
    const detailResponse = useDetailRound(round.id);
    const link = `/rounds/${round.id}?rows=${sugg.rows}&dif=${sugg.dif}&numFull=${sugg.numFull}&numHalf=${sugg.numHalf}`;

    let logo: string = "";
    let gradient: string = 'linear-gradient(335deg,#A8301F,#FA9547,#D09C72,#B74D01)';

    let background: string = 'var(--background_4)';

    let gridBorder: string = "0px";
    let boxShadow: string = "rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px";
    let minMaxFlexTextColor: string = 'var(--text-white)';
    let numberImage: string = "";
    let numberBackgroundHeight: string = "64px";
    let numberBackgroundWidth: string = "77px";
    let buttonMargin: string = "inherit";
    let fontFamily: string = 'var(--font-title)';
    let numberIcon: ReactNode = "";
    let borderBottom: string = "";
    let proPickButtonColor: string = "";

    let padding: string = "6px 45.5px";

    let border: string = "";

    let mixMaxFlex: string = "";
    let number: string = "";
    let logoHeight: string = "44px";
    let logoHeight2: string = "35px";
    let logoWidth: string = "100px";
    let borderImageSource: string = "none";

    let smallText: SxProps<Theme> = {
        fontSize: "10px",
        color: 'var(--font-color-supportive)',
        lineHeight: "15px",
        fontWeight: "400",
        fontFamily: 'var(--font-body)',
        marginTop: '4px',
        marginBottom: '7px',
    };

    let mixMaxFlexNumberStyle: SxProps<Theme> = {
        fontSize: "40px",
        fontFamily: 'var(--font-title)',
        color: 'var(--text-white)',
        fontWeight: "800",
        marginTop: "-10px"
    };

    let minMaxFlexStyle: SxProps<Theme> = {
        fontSize: "12px",
        fontFamily: 'var(--font-title)',
        color: 'var(--text-white)',
        fontWeight: "400",
        textTransform: "uppercase",
        marginTop: "0px"
    }

    let numberStyle: SxProps<Theme> = {
        fontSize: "20px",
        color: 'var(--text-black)',
        lineHeight: "30px",
        fontWeight: "700",
        fontFamily: IsLeo(window.theme) ? 'var(--font-title)' : 'var(--font-body)',
        marginTop: '0px',
        marginBottom: '5px'
    }

    let dateText: SxProps<Theme> = smallText;
    
    // Determine round type once
    const isMax = round.name.indexOf("Max") > -1;
    const isMix = round.name.indexOf("Mix") > -1;
    const isHockey = round.name.indexOf("Hockey") > -1;

    // Helper to set common properties for gradient-based themes
    const setCommonGradientTheme = () => {
        logo = "none";
        logoHeight = "70px";
        logoHeight2 = "70px";
        logoWidth = "100%";
        boxShadow = "0px 1px 3px 0px #00000040";
        border = "double " + gridBorder + " transparent";
    };

    if (window.theme === themeC.Orange) {
        const isLight = IsOrangeLight(window.theme);
        logo = "none";
        logoHeight = "56px";
        logoHeight2 = "56px";
        logoWidth = "100%";
        background = isLight ? '#FFFFFF' : '#1E1E1E';
        border = isLight ? '1px solid #DDDDDD' : '1px solid #575757';
        boxShadow = '0px 1px 13px -2px rgba(16, 24, 40, 0.08)';
        gradient = isLight ? 'linear-gradient(90deg, #FFF0E0 0%, #FFFFFF 100%)' : 'linear-gradient(90deg, #241D15 0%, #1E1E1E 30%)';
        mixMaxFlex = productNamesC.Orange.Flex;
        number = GetFlexNumber(round.name);
        numberStyle = { ...numberStyle, color: isLight ? '#1F1F1F' : '#F0F0F0', fontSize: '18px', fontWeight: 400, lineHeight: '24px' };
        smallText = { ...smallText, color: isLight ? '#636363' : '#B3B3B3', fontSize: '14px', marginTop: '12px', marginBottom: '12px' };
        dateText = { ...dateText, color: isLight ? '#636363' : '#B3B3B3', fontSize: '14px', marginTop: '12px', marginBottom: '12px' };
        padding = "12px 24px";
        buttonMargin = "0px 12px";

        if (isMax) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
        }

        if (isMix) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
        }
    }

    if (window.theme === themeC.GoGo) {
        logo = "none";
        logoHeight = "56px";
        logoHeight2 = "56px";
        logoWidth = "100%";
        background = 'linear-gradient(90deg, #1E1E1E 30.53%, #1E1E1E 100%)';
        border = '1px solid #575757';
        boxShadow = '0px 1px 13px -2px rgba(16, 24, 40, 0.08)';
        gradient = 'linear-gradient(90deg, rgba(37, 37, 37, 0.24) 0%, rgba(37, 37, 37, 0.24) 100%), linear-gradient(0deg, #1B4B30 0%, #1B4B30 100%)';
        mixMaxFlex = productNamesC.Orange.Flex;
        number = GetFlexNumber(round.name);
        numberStyle = { ...numberStyle, color: '#F0F0F0', fontSize: '18px', fontWeight: 400, lineHeight: '24px' };
        smallText = { ...smallText, color: '#B3B3B3', fontSize: '14px', marginTop: '12px', marginBottom: '12px' };
        dateText = { ...dateText, color: '#B3B3B3', fontSize: '14px', marginTop: '12px', marginBottom: '12px' };

        if (isMax) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
        }

        if (isMix) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
        }
    }

    if (window.theme === themeC.Wood) {
        logo = "none";
        logoHeight = "57px";
        logoHeight2 = "57px";
        logoWidth = "100%";
        background = 'linear-gradient(90deg, #1E1E1E 30.53%, #1E1E1E 100%)';
        border = '1px solid #575757';
        boxShadow = '0px 1px 13px -2px rgba(16, 24, 40, 0.08)';
        gradient = 'linear-gradient(90deg, rgba(30, 30, 30, 0.24) 0%, rgba(30, 30, 30, 0.24) 100%), linear-gradient(0deg, #14665D 0%, #14665D 100%)';
        mixMaxFlex = productNamesC.Orange.Flex;
        number = GetFlexNumber(round.name);
        numberStyle = { ...numberStyle, color: '#F0F0F0', fontSize: '18px', fontWeight: 500, lineHeight: '24px', fontFamily: "'GT-America'" };
        smallText = { ...smallText, color: '#B3B3B3', fontSize: '14px', marginTop: '12px', marginBottom: '12px', fontFamily: "'GT-America'" };
        dateText = { ...dateText, color: '#B3B3B3', fontSize: '14px', marginTop: '12px', marginBottom: '12px', fontFamily: "'GT-America'" };

        if (isMax) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
        }

        if (isMix) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
        }
    }

    if (window.theme === themeC.Lion) {
        logo = "none";
        logoHeight = "57px";
        logoHeight2 = "57px";
        logoWidth = "100%";
        background = '#FFFFFF';
        border = '1px solid #DDDDDD';
        boxShadow = '0px 1px 13px -2px rgba(16, 24, 40, 0.08)';
        gradient = 'linear-gradient(90deg, #FFF3F1 0%, #FFFFFF 100%)';
        mixMaxFlex = productNamesC.Orange.Flex;
        number = GetFlexNumber(round.name);
        numberStyle = { ...numberStyle, color: '#1F1F1F', fontSize: '18px', fontWeight: 400, lineHeight: '24px' };
        smallText = { ...smallText, color: '#636363', fontSize: '14px', lineHeight: '20px', marginTop: '12px', marginBottom: '12px' };
        dateText = { ...dateText, color: '#636363', fontSize: '14px', lineHeight: '20px', marginTop: '12px', marginBottom: '12px' };
        padding = "12px 24px";
        buttonMargin = "0px 12px";
        proPickButtonColor = "#FD5C3C";

        if (isMax) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
        }

        if (isMix) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
        }
    }

    if (window.theme === themeC.Green) {
        setCommonGradientTheme();
        mixMaxFlex = isHockey ? "Hockey" : "Rätt";
        number = "8";
        gradient = isHockey ? `url(${unibet_hockey})` : `url(${unibet_football})`;
        padding = "12px 35px";
        logoHeight = "70px";
        logoHeight2 = "70px";
        mixMaxFlexNumberStyle = { ...mixMaxFlexNumberStyle, fontFamily: 'UnibetPro' };

        if (isMax) {
            mixMaxFlex = isHockey ? "Hockey" : "Rätt";
            number = "13";
        }

        if (isMix) {
            mixMaxFlex = isHockey ? "Hockey" : "Rätt";
            number = "12";
        }
    }

    if (window.theme === themeC.ComeOn) {
        logo = "none";
        logoHeight = "67.5px";
        logoHeight2 = "70px";
        logoWidth = "100%";
        boxShadow = "0px 1px 3px 0px #00000040";
        border = "double " + gridBorder + " transparent";
        padding = "12px 35px";
        gradient = `url(${comeon8})`;
        mixMaxFlexNumberStyle.fontFamily = 'Gravity';
        minMaxFlexStyle.fontSize = "18px";

        if (isMax) {
            gradient = `url(${comeon13})`;
        }

        if (isMix) {
            gradient = `url(${comeon12})`;
        }
    }

    if (window.theme === themeC.Hajper) {
        logo = "none";
        logoHeight = "67px";
        logoHeight2 = "67px";
        logoWidth = "100%";
        boxShadow = "0px 1px 3px 0px #00000040";
        padding = "12px 35px";
        number = "8";
        background = 'linear-gradient(308.65deg, #091137 3.32%, #11226E 62.17%)';
        gradient = `url(${hajper8})`;
        mixMaxFlexNumberStyle.fontFamily = "HajperDisplay";
        mixMaxFlexNumberStyle.marginTop = "-5px";
        border = "1px solid #2640C3";

        if (isMax) {
            number = "13";
            gradient = `url(${hajper13})`;
        }

        if (isMix) {
            number = "12";
            gradient = `url(${hajper12})`;
        }
    }

    if (window.theme === themeC.Snabbare) {
        logo = "none";
        logoHeight = "67px";
        logoHeight2 = "67px";
        logoWidth = "100%";
        boxShadow = "0px 1px 3px 0px #00000040";
        border = "double " + gridBorder + " transparent";
        padding = "12px 35px";
        gradient = `url(${snabbare8})`;

        if (isMax) {
            gradient = `url(${snabbare13})`;
        }

        if (isMix) {
            gradient = `url(${snabbare12})`;
        }
    }

    if (window.theme === themeC.Reviant) {
        logo = "none";
        logoHeight = "67px";
        logoHeight2 = "67px";
        logoWidth = "100%";
        boxShadow = "none";
        border = "0.666667px solid rgba(0, 0, 0, 0.1)";
        padding = "12px 35px";
        number = "8";
        gradient = `url(${reviantBg})`;
        mixMaxFlex = productNamesC.ComeOn.Flex;
        minMaxFlexTextColor = "#E71F00";
        minMaxFlexStyle = { ...minMaxFlexStyle, color: '#E71F00' };
        mixMaxFlexNumberStyle = { ...mixMaxFlexNumberStyle, color: '#E71F00' };

        if (isMax) {
            mixMaxFlex = productNamesC.ComeOn.Max;
            number = "13";
        }

        if (isMix) {
            mixMaxFlex = productNamesC.ComeOn.Mix;
            number = "12";
        }
    }

    if (window.theme === themeC.Lyllo) {
        setCommonGradientTheme();
        logoHeight = "67px";
        logoHeight2 = "67px";
        mixMaxFlex = productNamesC.ComeOn.Flex;
        number = "8";
        gradient = gradientsC.Lyllo.Flex;
        padding = "12px 35px";
        borderBottom = "none";

        if (isMax) {
            mixMaxFlex = productNamesC.ComeOn.Max;
            number = "13";
            gradient = gradientsC.Lyllo.Max;
        }

        if (isMix) {
            mixMaxFlex = productNamesC.ComeOn.Mix;
            number = "12";
            gradient = gradientsC.Lyllo.Mix;
        }
    }

    if (window.theme === themeC.Stugan) {
        logo = "none";
        logoHeight = "67px";
        logoHeight2 = "67px";
        logoWidth = "100%";
        boxShadow = "0px 1px 3px 0px #00000040";
        border = "double " + gridBorder + " transparent";
        padding = "12px 35px";
        gradient = `url(${stugan8})`;

        if (isMax) {
            gradient = `url(${stugan13})`;
        }

        if (isMix) {
            gradient = `url(${stugan12})`;
        }
    }

    if (window.theme === themeC.Kryss) {
        setCommonGradientTheme();
        mixMaxFlex = productNamesC.Paf.Flex;
        number = "8";
        gradient = gradientsC.Kryss.Flex;
        padding = "12px 35px";

        if (isMax) {
            mixMaxFlex = productNamesC.Paf.Max;
            number = "13";
            gradient = gradientsC.Kryss.Max;
        }

        if (isMix) {
            mixMaxFlex = productNamesC.Paf.Mix;
            number = "12";
            gradient = gradientsC.Kryss.Mix;
        }
    }

    if (window.theme === themeC.Hard) {
        logo = "none";
        logoHeight = "77px";
        logoHeight2 = "77px";
        logoWidth = "100%";
        boxShadow = "0px 1px 3px 0px #00000040";
        border = "double " + gridBorder + " transparent";
        padding = "12px 35px";
        gradient = isHockey ? `url(${hard9})` : `url(${hard8})`;

        if (isMax) {
            gradient = `url(${hard13})`;
        }

        if (isMix) {
            gradient = `url(${hard12})`;
        }
    }


    if ((window.theme === themeC.Kung)) {
        logo = "none";
        logoHeight = "75px";
        logoHeight2 = "75px";
        logoWidth = "100%";
        border = "double " + gridBorder + " transparent";
        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        number = GetFlexNumber(round.name);
        gradient = gradientsC.Kung.Flex;
        minMaxFlexTextColor = "#27FFAA";
        numberImage = kung8;
        numberBackgroundHeight = "46px";
        numberBackgroundWidth = "34.69px";
        buttonMargin = "10px 15px 0px 15px";
        padding = "12px 35px";

        dateText = {
            ...dateText,
            fontSize: "14px",
            marginTop: "15px",
            marginBottom: "0px"
        };

        smallText = {
            ...smallText,
            fontSize: "14px",
            marginTop: "10px",
            marginBottom: "10px"
        };

        if (isMax) {
            number = "13";
            gradient = gradientsC.Kung.Max;
            minMaxFlexTextColor = "#34C2FF";
            numberImage = kung13;
            numberBackgroundHeight = "46px";
            numberBackgroundWidth = "55px";
        }

        if (isMix) {
            number = "12";
            gradient = gradientsC.Kung.Mix;
            minMaxFlexTextColor = "#EE8DFF";
            numberImage = kung12;
            numberBackgroundHeight = "46px";
            numberBackgroundWidth = "56.93px";
        }

        numberImage = `url(${numberImage})`;
    }

    if ((window.theme === themeC.Dbet)) {
        logo = "none";
        logoHeight = "87px";
        logoHeight2 = "80px";
        logoWidth = "100%";
        numberStyle = {
            ...numberStyle,
            fontWeight: 900
        };
        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        number = GetFlexNumber(round.name);
        gradient = gradientsC.Dbet.Flex;
        minMaxFlexTextColor = "#F4C004";
        numberBackgroundHeight = "46px";
        numberBackgroundWidth = "75px";
        buttonMargin = "10px 15px 0px 15px";
        padding = "8px 35px";
        fontFamily = "Righteous";
        numberIcon =
            <Grid container direction="row" alignItems="center" >
                <Grid sx={{ marginRight: "7px", paddingLeft: "18px" }}>
                    {DbetEightIcon(48, 35.53)}
                </Grid>
                {DbetEightLadder(20, 12)}
            </Grid>

        if (round.name.indexOf("Survivor6") > -1) {
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "7px", paddingLeft: "18px" }}>
                        {DbetSixIcon(48, 35.53)}
                    </Grid>
                    {DbetEightLadder(20, 12)}
                </Grid>
        }

        if (isHockey) {
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "7px", paddingLeft: "18px" }}>
                        {DbetSevenIcon(48, 35.53)}
                    </Grid>
                    {DbetEightLadder(20, 12)}
                </Grid>
        }

        dateText = {
            ...dateText,
            fontSize: "14px",
            marginTop: "15px",
            marginBottom: "0px"
        };

        if (isMax) {
            number = "13";
            gradient = gradientsC.Dbet.Max;
            numberBackgroundHeight = "46px";
            numberBackgroundWidth = "100px";
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "-15px", marginLeft: "0px" }}>
                        {DbetThirteenIcon(48, 97)}
                    </Grid>
                    {DbetThirteenLadder(20, 12)}
                </Grid>
        }

        if (isMix) {
            number = "12";
            gradient = gradientsC.Dbet.Mix;
            numberBackgroundHeight = "46px";
            numberBackgroundWidth = "100px";
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "-15px", paddingLeft: "0px" }}>
                        {DbetTwelveIcon(48, 100)}
                    </Grid>
                    {DbetTwelveLadder(20, 12)}
                </Grid>
        }
    }

    if ((window.theme === themeC.Video)) {
        logo = "none";
        logoHeight = "70px";
        logoHeight2 = "80px";
        logoWidth = "100%";
        border = "double " + gridBorder + " transparent";
        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        gradient = `url(${video8})`;
        minMaxFlexTextColor = "#7EFFB2";
        buttonMargin = "10px 15px 0px 15px";
        padding = "8px 35px";
        fontFamily = "Tilt Warp";

        dateText = {
            ...dateText,
            fontSize: "14px",
            marginTop: "15px",
            marginBottom: "0px"
        };

        smallText = {
            ...smallText,
            fontSize: "14px",
            marginTop: "10px",
            marginBottom: "10px"
        };

        if (isMax) {
            gradient = `url(${video13})`;
            minMaxFlexTextColor = "#FFF3B7";
        }

        if (isMix) {
            gradient = `url(${video12})`;
            minMaxFlexTextColor = "#D47EDD";
        }
    }

    if ((window.theme === themeC.MrVegas)) {
        logo = "none";
        logoHeight = "80px";
        logoHeight2 = "80px";
        logoWidth = "100%";
        border = "double " + gridBorder + " transparent";
        gradient = `url(${mrvegas8})`;
        buttonMargin = "10px 15px 0px 15px";
        padding = "8px 35px";
        fontFamily = "Tilt Warp";

        dateText = {
            ...dateText,
            fontSize: "14px",
            marginTop: "15px",
            marginBottom: "0px"
        };

        smallText = {
            ...smallText,
            fontSize: "14px",
            marginTop: "10px",
            marginBottom: "10px"
        };

        if (isMax) {
            gradient = `url(${mrvegas13})`;
        }

        if (isMix) {
            gradient = `url(${mrvegas12})`;
        }
    }

    if ((window.theme === themeC.Mega)) {
        logo = "none";
        logoHeight = "67.5px";
        logoHeight2 = "80px";
        logoWidth = "100%";
        border = "double " + gridBorder + " transparent";
        gradient = `url(${mega8})`;
        buttonMargin = "10px 15px 0px 15px";
        padding = "8px 35px";

        dateText = {
            ...dateText,
            fontSize: "14px",
            marginTop: "15px",
            marginBottom: "0px"
        };

        smallText = {
            ...smallText,
            fontSize: "14px",
            marginTop: "10px",
            marginBottom: "10px"
        };

        if (isMax) {
            gradient = `url(${mega13})`;
        }

        if (isMix) {
            gradient = `url(${mega12})`;
        }
    }

    if (round.name.indexOf("Survivor") > -1) {
        mixMaxFlex = (window as any).theme === themeC.Green ? 'Stegen' : t('survivor8');
        number = GetFlexNumber(round.name);
    }

    // Survivor-specific override for Hajper theme: the survivor label is
    // rendered via Hajper's own sub-label beneath the number (see the Hajper
    // render block), so blank the top label here to avoid doubling it. Mirrors
    // roundboxwithbutton.tsx.
    if (round.name.indexOf("Survivor") > -1 && window.theme === themeC.Hajper) {
        mixMaxFlex = "";
    }

    // Survivor-specific override for Stugan theme: swap to the survivor ribbon
    // artwork (mirrors roundboxwithbutton.tsx). The Stugan block above set the
    // gradient to the plain stugan8 tile, so override it here after the generic
    // survivor block has run.
    if (round.name.indexOf("Survivor") > -1 && window.theme === themeC.Stugan) {
        gradient = `url(${round.name.indexOf("Survivor6") > -1 ? stuganSurvivor6 : stuganSurvivor8})`;
        // Number/label are baked into the artwork; the generic survivor block
        // above already set these, so blank them here to avoid doubled text.
        mixMaxFlex = "";
        number = "";
    }

    // Survivor-specific override for Snabbare theme: swap to the survivor artwork.
    if (round.name.indexOf("Survivor") > -1 && window.theme === themeC.Snabbare) {
        gradient = `url(${round.name.indexOf("Survivor6") > -1 ? snabbareSurvivor6 : snabbareSurvivor8})`;
        // Number/label are baked into the artwork; blank them to avoid doubled text.
        mixMaxFlex = "";
        number = "";
    }

    // Survivor-specific override for Hard/Bethard theme: swap to the Tipsraketen plate.
    // "Tipsraketen" is baked in and the plate has no round number; blank both.
    if (round.name.indexOf("Survivor") > -1 && window.theme === themeC.Hard) {
        gradient = `url(${hardSurvivor})`;
        mixMaxFlex = "";
        number = "";
    }

    const reportSelection = () => {
        setOrigin("landing", "pro_pick_box");
        track("select_content", { content_type: "round", content_id: "pro_pick_box" });
    }

    return (

        <Grid sx={{
            width: "160px",
            border: border,
            borderRadius: 'var(--radius)',
            backgroundImage: borderImageSource,
            backgroundOrigin: "border-box",
            backgroundClip: "padding-box, border-box",
            padding: gridBorder,
            margin: "5px",
            boxShadow: boxShadow
        }}>
            <Grid container direction='column' alignItems='center'
                sx={{
                    background: background,
                    margin: '0px',
                    borderRadius: 'var(--radius)'
                }}>

                <Grid container justifyContent='center' alignItems='center' sx={{
                    backgroundImage: gradient,
                    width: '100%',
                    height: logoHeight,
                    backgroundSize: (window.theme === themeC.MrVegas || window.theme === themeC.Green) ? (window.theme === themeC.Green ? (isHockey ? '110% auto' : '160% auto') : 'cover') : 'contain',
                    backgroundPosition: window.theme === themeC.Green ? (isHockey ? '-28px -73px' : 'center 64%') : undefined,
                    borderTopLeftRadius: 'var(--radius)',
                    borderTopRightRadius: 'var(--radius)',
                    overflow: 'hidden',
                    borderBottom: borderBottom,
                    ...(window.theme === themeC.Orange ? { borderLeft: '3px solid #FE8000' } : {}),
                    ...(window.theme === themeC.Lion ? { borderLeft: '3px solid #FD5C3C' } : {})
                }}>
                    <Grid item sx={{
                        width: logoWidth,
                        height: logoHeight2,
                        backgroundImage: logo === "none" ? 'none' : `url(${logo})`,
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}>

                        {(IsLeo(window.theme) && window.theme !== themeC.GoGo && window.theme !== themeC.Wood && window.theme !== themeC.Orange && window.theme !== themeC.Green && window.theme !== themeC.Lion) &&
                            <Grid direction="column" container alignItems="center" sx={{ marginTop: "5px" }}>
                                <Typography sx={minMaxFlexStyle}>
                                    {mixMaxFlex}
                                </Typography>
                                <Typography sx={mixMaxFlexNumberStyle}>
                                    {number}
                                </Typography>
                                {window.theme === themeC.Hajper &&
                                    <Typography sx={{ fontWeight: 500, fontSize: "12px", marginTop: "-14px" }}>
                                        {round.name.indexOf("Survivor") > -1 ? t('survivor8') : 'Matcher'}
                                    </Typography>
                                }
                            </Grid>
                        }

                        {window.theme === themeC.Green &&
                            <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                                <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: isHockey ? 'linear-gradient(0deg, rgba(14, 60, 22, 0.25) 75%, rgba(62, 171, 55, 0.125) 100%)' : 'linear-gradient(180deg, rgba(14, 60, 22, 0.5) 30%, rgba(62, 171, 55, 0.5) 100%)', borderRadius: 'inherit' }} />
                                <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', gap: '4px' }}>
                                    <Typography sx={{
                                        fontFamily: 'UnibetPro',
                                        fontStyle: 'normal',
                                        fontWeight: 500,
                                        fontSize: '40px',
                                        lineHeight: '32px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        color: '#FFFFFF',
                                    }}>
                                        {number}
                                    </Typography>
                                    <Typography sx={{
                                        fontFamily: 'UnibetPro',
                                        fontWeight: 500,
                                        fontSize: '12px',
                                        lineHeight: '12px',
                                        color: '#FFFFFF',
                                        textTransform: 'uppercase',
                                    }}>
                                        {mixMaxFlex}
                                    </Typography>
                                </Box>
                            </Box>
                        }

                        {IsVideo(window.theme) &&
                            <Grid direction="column" container alignItems="center" sx={{ marginTop: "5px" }}>
                                <Typography sx={{
                                    fontSize: "12px",
                                    fontFamily: fontFamily,
                                    color: minMaxFlexTextColor,
                                    fontWeight: window.theme === themeC.Kung ? "700" : "400",
                                    textTransform: window.theme === themeC.Video ? "none" : "uppercase",
                                    marginTop: window.theme === themeC.Video ? "-3px" : "0px",

                                }}>
                                    {mixMaxFlex}
                                </Typography>
                                <Box
                                    sx={{
                                        backgroundImage: numberImage,
                                        backgroundSize: "contain",
                                        backgroundRepeat: "no-repeat",
                                        height: numberBackgroundHeight,
                                        width: numberBackgroundWidth
                                    }}
                                >
                                    {numberIcon}
                                </Box>
                            </Grid>
                        }

                        {(window.theme === themeC.GoGo || window.theme === themeC.Wood || window.theme === themeC.Orange || window.theme === themeC.Lion) &&
                            <Grid direction="column" container alignItems="center" justifyContent="center" sx={{ height: "100%" }}>
                                <Typography sx={{
                                    fontSize: "12px",
                                    fontFamily: window.theme === themeC.Wood ? "'GT-America'" : 'var(--font-title)',
                                    color: (window.theme === themeC.Lion || IsOrangeLight(window.theme)) ? '#1F1F1F' : '#F0F0F0',
                                    fontWeight: (window.theme === themeC.Wood || window.theme === themeC.Orange || window.theme === themeC.Lion) ? 700 : 400,
                                    textTransform: "uppercase",
                                    lineHeight: "16px"
                                }}>
                                    {mixMaxFlex} {number}
                                </Typography>
                            </Grid>
                        }
                    </Grid>
                </Grid>

                <Grid container direction='column' alignItems='center'>
                    <Typography sx={dateText}>{dateString}</Typography>
                    <Typography sx={numberStyle}>{detailResponse.round &&
                        getProPickText(sugg.rows, detailResponse.round.operatorStakePerRow, detailResponse.round.operatorFeePerRow ?? { amount: 0 }, t)}</Typography>

                    <Link to={link}>
                        <div onClick={() => reportSelection()}>
                            <Button margin={buttonMargin} padding={padding} color={proPickButtonColor || undefined} borderRadius={proPickButtonColor ? '24px' : undefined} textColor={proPickButtonColor ? '#1F1F1F' : undefined}>{t('bet_now')}</Button>
                        </div>
                    </Link>
                    <Typography sx={smallText}>{sugg.rows} {t('rows')}</Typography>
                </Grid>
            </Grid>
        </Grid>

    );

}

export default RobotPlateSlim;
